import styled from 'styled-components';

export const HeaderWrapper = styled.header`
    width: 100%;

    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    padding: 8px 28px;

    background-color: ${({ theme }) => theme.palette.common.white};
`;
